/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationResponse } from './NotificationResponse';
import {
    NotificationResponseFromJSON,
    NotificationResponseFromJSONTyped,
    NotificationResponseToJSON,
    NotificationResponseToJSONTyped,
} from './NotificationResponse';

/**
 * 
 * @export
 * @interface MarkNotificationReadResponse
 */
export interface MarkNotificationReadResponse {
    /**
     * 
     * @type {NotificationResponse}
     * @memberof MarkNotificationReadResponse
     */
    notification: NotificationResponse;
}

/**
 * Check if a given object implements the MarkNotificationReadResponse interface.
 */
export function instanceOfMarkNotificationReadResponse(value: object): value is MarkNotificationReadResponse {
    if (!('notification' in value) || value['notification'] === undefined) return false;
    return true;
}

export function MarkNotificationReadResponseFromJSON(json: any): MarkNotificationReadResponse {
    return MarkNotificationReadResponseFromJSONTyped(json, false);
}

export function MarkNotificationReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkNotificationReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'notification': NotificationResponseFromJSON(json['notification']),
    };
}

export function MarkNotificationReadResponseToJSON(json: any): MarkNotificationReadResponse {
    return MarkNotificationReadResponseToJSONTyped(json, false);
}

export function MarkNotificationReadResponseToJSONTyped(value?: MarkNotificationReadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification': NotificationResponseToJSON(value['notification']),
    };
}

